'use strict';

var addPointerEvent = require('../../events/add-pointer-event.cjs');
var Feature = require('../../motion/features/Feature.cjs');
var getContextWindow = require('../../utils/get-context-window.cjs');
var PanSession = require('./PanSession.cjs');
var noop = require('../../../../../../../motion-utils/dist/es/noop.cjs');
var frame = require('../../../../../../../motion-dom/dist/es/frameloop/frame.cjs');

const asyncHandler = (handler) => (event, info) => {
    if (handler) {
        frame.frame.postRender(() => handler(event, info));
    }
};
class PanGesture extends Feature.Feature {
    constructor() {
        super(...arguments);
        this.removePointerDownListener = noop.noop;
    }
    onPointerDown(pointerDownEvent) {
        this.session = new PanSession.PanSession(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: getContextWindow.getContextWindow(this.node),
        });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info) => {
                delete this.session;
                if (onPanEnd) {
                    frame.frame.postRender(() => onPanEnd(event, info));
                }
            },
        };
    }
    mount() {
        this.removePointerDownListener = addPointerEvent.addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

exports.PanGesture = PanGesture;
//# sourceMappingURL=index.cjs.map
